import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FaRegTrashCan } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa";

function RefrigerationExpo({ onClose, valorActualExpo, actualizarTarifa, concepto }) {
  const [data, setData] = useState([]);
  const [cargoMinimo, setCargoMinimo] = useState("");

  // Cargar datos iniciales simulados
  useEffect(() => {
    if (valorActualExpo) {
      setData(valorActualExpo.tabla || []);
      setCargoMinimo(valorActualExpo.cargoMinimo || "");
    }
  }, [valorActualExpo]);

  const agregarFila = () => {
    const nuevaFila = { v1: "", v2: "", v3: "", activo: false };
    setData([...data, nuevaFila]);
  };

  const eliminarFila = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  const handleChange = (index, campo, valor) => {
    const nuevaData = [...data];
    nuevaData[index][campo] = valor;
    setData(nuevaData);
  };

  const handleActualizar = () => {
    actualizarTarifa(concepto, {
      tabla: data,
      cargoMinimo: cargoMinimo,
    });

    Swal.fire({
      title: "Éxito",
      text: "Montos actualizados con éxito",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left">
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">REFRIGERACIÓN (MXN)</label>
          </div>

          <div className="row">
            <div className="table-responsive">
              <table className="table table-inverse table-hover table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>De</th>
                    <th>A</th>
                    <th>Factor</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((fila, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={fila.v1}
                          onChange={(e) =>
                            handleChange(index, "v1", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={fila.v2}
                          onChange={(e) =>
                            handleChange(index, "v2", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={fila.v3}
                          onChange={(e) =>
                            handleChange(index, "v3", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <FaRegTrashCan
                          style={{ cursor: "pointer", color: "black" }}
                          onClick={() => eliminarFila(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="text-center mb-4">
                <button className="btnn" onClick={agregarFila}>
                  <FaPlus />
                </button>
              </div>
            </div>
          </div>

          {/* CARGO MINIMO */}
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">CARGO MÍNIMO:</label>

            <div className="d-flex align-items-center flex-wrap gap-2">
              <input
                type="number"
                className="form-control form-control-sm"
                style={{ width: "200px" }}
                value={cargoMinimo}
                onChange={(e) => setCargoMinimo(e.target.value)}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>Actualizar</button>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default RefrigerationExpo;
